import { useEffect, useState } from 'react';

type Props = {
  logoUrl: string;
  watermarkCode: string | null;
};

// Posiciones predefinidas para el código dinámico — rotar entre ellas (en vez
// de mover continuamente) dificulta que un crop/mask fijo lo recorte, ver
// openspec/changes/academy-video-watermark/design.md Decisión 1.
const CODE_POSITIONS = [
  'left-4 top-4',
  'right-4 top-4',
  'left-4 bottom-24',
  'right-4 bottom-24',
  'left-1/2 top-4 -translate-x-1/2',
] as const;

const CODE_ROTATE_MIN_MS = 25_000;
const CODE_ROTATE_JITTER_MS = 10_000;

function nextRotateDelay(): number {
  return CODE_ROTATE_MIN_MS + Math.random() * CODE_ROTATE_JITTER_MS;
}

export default function VideoWatermarkOverlay({ logoUrl, watermarkCode }: Props) {
  const [positionIndex, setPositionIndex] = useState(0);
  const [opacity, setOpacity] = useState(0.16);

  useEffect(() => {
    if (!watermarkCode) return;

    let timeoutId: number;
    const rotate = () => {
      setPositionIndex((prev) => (prev + 1) % CODE_POSITIONS.length);
      setOpacity(0.12 + Math.random() * 0.13);
      timeoutId = window.setTimeout(rotate, nextRotateDelay());
    };
    timeoutId = window.setTimeout(rotate, nextRotateDelay());

    return () => window.clearTimeout(timeoutId);
  }, [watermarkCode]);

  return (
    <div className="pointer-events-none absolute inset-0 z-10 select-none">
      <img
        src={logoUrl}
        alt=""
        aria-hidden="true"
        className="absolute bottom-[4.5rem] right-4 h-6 w-auto opacity-20 sm:h-8"
      />

      {watermarkCode && (
        <span
          className={`absolute rounded bg-black/30 px-2 py-1 font-mono text-micro tracking-wider text-white transition-[opacity,transform] duration-1000 motion-reduce:transition-none ${CODE_POSITIONS[positionIndex]}`}
          style={{ opacity }}
        >
          ALAS · {watermarkCode}
        </span>
      )}
    </div>
  );
}
